$('.table').each(function() {
	var table = $(this);

	table.find('table thead th').each(function(i, th){
		table.find('table tbody td:nth-child(' + (i+1) + ')').attr('data-label', $(th).text());
	});
});
